<template>
  <figure class="block-image">
    <Image :filename="block.content.image?.[0]" :context="context" sizes="90vw" />
    <figcaption v-if="block.content.caption" v-html="block.content.caption" />
  </figure>
</template>

<script setup>
defineProps(['block', 'context'])
</script>

<style scoped>
.block-image img { width: 100%; }

figcaption {
  margin-top: 1rem;
  font-size: 1.1rem;
  opacity: 0.5;
  max-width: 40em;
}
</style>
